import { useSyncExternalStore } from "react";

// =============================================================================

const QUERY = "(prefers-reduced-motion: reduce)";

function subscribe(onChange: () => void) {
  const media = window.matchMedia(QUERY);
  media.addEventListener("change", onChange);
  return () => media.removeEventListener("change", onChange);
}

/**
 * prefers-reduced-motion without hydration mismatch: false on the server and
 * while hydrating (like the server HTML), then the real preference. Use it
 * instead of motion's useReducedMotion whenever it changes the markup.
 */
export function usePrefersReducedMotion(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => window.matchMedia(QUERY).matches,
    () => false
  );
}

// =============================================================================
